<template>
  <v-table v-if="result" fixed-header style="overflow-x: scroll">
    <thead>
    <tr>
      <th class="text-left font-weight-bold text-center">
        ПОДРАЗДЕЛЕНИЕ
      </th>
      <th class="text-left font-weight-bold text-center">
        ТО, %
      </th>
      <th class="text-left font-weight-bold text-center">
        ИСПЫТАНИЯ, %
      </th>
      <th class="text-left font-weight-bold text-center" width="300">
        Среднее время реагирования, ч/ч
      </th>
      <th class="text-left font-weight-bold text-center" width="300">
        Среднее время устранения, ч/ч
      </th>
      <th class="text-left font-weight-bold text-center" width="300">
        Кол-во обращений
        <Legend_Appeals />
      </th>
      <th class="text-left font-weight-bold text-center" width="300">
        Недельная выработка, ч/ч
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="district in result.data" :key="district">
      <td>
        <v-sheet class="d-flex justify-start align-center" height="100%">
          <p>{{ district.department.replace("Производственный участок в ", "")  }}<br>{{ district.chief_name }}</p>
        </v-sheet>
      </td>
      <td>
        <Report__Percent :report_data=" district.stats.percent_tech_service" />
      </td>
      <td>
        <Report__Percent :report_data=" district.stats.percent_trials" />
      </td>
      <td>
        <ReportByWeek name="Среднее время реакции" :guid="`${district.guid}_average_time_reaction`" :report_data=" district.stats.average_time_reaction" />
      </td>
      <td>
        <ReportByWeek name="Среднее время устранения" :guid="`${district.guid}_average_time_fixing`" :report_data=" district.stats.average_time_fixing" />
      </td>
      <td>
        <Report__Appeals name="Кол-во обращений" :guid="`${district.guid}_count_of_appeals`" :report_data=" district.stats.count_of_appeals" />
      </td>
      <td>
        <Report__WeeklyWorkHours name="Недельная выработка" :guid="`${district.guid}_weekly_work`" :report_data=" district.stats.weekly_work" />
      </td>
    </tr>
    </tbody>
  </v-table>
  <Loader v-else />
</template>

<script>
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { ErrorStore } from "@/store/ErrorStore";
import ReportByWeek from "@/components/StatsBoard/ReportByWeek.vue";
import route_check from "@/libs/route_check";
import Loader from "@/components/Different/Loader.vue";
import Report__Appeals from "@/components/StatsBoard/Report__Appeals.vue";
import Report__WeeklyWorkHours from "@/components/StatsBoard/Report__WeeklyWorkHours.vue";
import Report__Percent from "@/components/StatsBoard/Report__Percent.vue";
import Legend_Appeals from "@/components/StatsBoard/Legend_Appeals.vue";

export default {
  name: "StatsBoard",
  components: {Legend_Appeals, Report__Percent, Report__WeeklyWorkHours, Report__Appeals, Loader, ReportByWeek },
  async beforeMount() {
    route_check('/dashboard/district_stats').then(async res => {
      if (!res) {
        this.$router.push({ name: 'home' })
      }
    })
  },
  async mounted() {
    await this.GetDistrictsStats()

  },
  data() {
    return {
      result: false
    }
  },
  watch: {
    selected (newFilter) {
      console.log('ИЗМЕНЕН ФИЛЬТР: ' + newFilter)
      this.sortTickets()
    }
  },
  methods: {
    GenerateCharts: function () {
      let canvases = document.getElementsByClassName('chart')
      console.log(canvases.length)
    },
    GetDistrictsStats: async function () {
      this.errors = []
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetDistrictsStats`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }
      console.log('Получаю данные...')
      await fetch(url, properies)
          .then(response => response.json())
          .then(result => {
            console.log('Успешно!')
            this.result = result

            this.GenerateCharts()
          }).catch(err => {
            console.log('Ошибка получения данных...')
            console.warn(err)
          })
    }
  },
  computed: {
    errors: {
      get() {
        return ErrorStore().get()
      },
      set(value) {
        ErrorStore().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  },
}
</script>

<style scoped>
</style>
